export * from './color-icon.component';
